<template>
  <aside class="arp-stepper">
    <div v-for="(step, index) in steps" :key="step.key" class="arp-stepper__item">
      <div class="arp-stepper__row">
        <span
          class="arp-stepper__marker"
          :class="{
            'is-done': index < activeIndex,
            'is-active': index === activeIndex,
            'is-todo': index > activeIndex,
            'is-success': step.key === 'done' && index === activeIndex,
            'is-check-only': step.key === 'done' && index !== activeIndex,
          }"
        >
          <b-icon v-if="step.key === 'done'" icon="check" size="is-small" />
          <span v-else>{{ index + 1 }}</span>
        </span>
        <div class="arp-stepper__labels">
          <p
            class="arp-stepper__title"
            :class="{
              'is-active': index === activeIndex,
              'is-success': step.key === 'done' && index === activeIndex,
            }"
          >
            {{ step.title }}
          </p>
          <p class="arp-stepper__subtitle">{{ step.subtitle }}</p>
        </div>
      </div>
      <div
        v-if="index < steps.length - 1"
        class="arp-stepper__connector"
        :class="{ 'is-done': index < activeIndex }"
      />
    </div>
  </aside>
</template>

<script>
export default {
  name: 'ArpStepper',
  props: {
    steps: {
      type: Array,
      required: true,
    },
    activeKey: {
      type: String,
      required: true,
    },
  },
  computed: {
    activeIndex() {
      const idx = this.steps.findIndex(s => s.key === this.activeKey);
      return idx < 0 ? 0 : idx;
    },
  },
};
</script>

<style scoped>
.arp-stepper {
  min-width: 240px;
  max-width: 280px;
  padding: 0.5rem 1rem 0.5rem 0;
}

.arp-stepper__row {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
}

.arp-stepper__marker {
  flex: 0 0 24px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 600;
  background: #fff;
  border: 1px solid #ccc;
  color: #7a7a7a;
}

.arp-stepper__marker.is-done,
.arp-stepper__marker.is-active {
  background: #214bb5;
  border-color: #214bb5;
  color: #fff;
}

.arp-stepper__marker.is-success {
  background: #2ea354;
  border-color: #2ea354;
  color: #fff;
}

.arp-stepper__marker.is-check-only {
  background: #fff;
  border-color: #ccc;
  color: #7a7a7a;
}

.arp-stepper__title {
  margin: 0;
  font-size: 0.875rem;
  font-weight: 500;
  color: #7a7a7a;
}

.arp-stepper__title.is-active {
  font-weight: 600;
  color: #214bb5;
}

.arp-stepper__title.is-success {
  font-weight: 600;
  color: #2ea354;
}

.arp-stepper__subtitle {
  margin: 0.125rem 0 0;
  font-size: 0.75rem;
  color: #7a7a7a;
}

.arp-stepper__connector {
  width: 2px;
  height: 20px;
  margin: 0 0 0 11px;
  background: #dbdbdb;
}

.arp-stepper__connector.is-done {
  background: #214bb5;
}
</style>
